var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class ChildrenAnalyzerError extends Error {
  constructor(message, options) {
    super(message, options);
    __publicField(this, "details");
    this.details = options?.details;
  }
}
export {
  ChildrenAnalyzerError
};
//# sourceMappingURL=ChildrenAnalyzerError.js.map
